import { useDataValue, useDataChange } from 'Simple/Data.js'

/** @type {import('Simple/types.js').useDataOnChange} */
export default function useDataOnChange(props) {
  let boardId = useDataValue({
    viewPath: props.viewPath,
    context: 'event_action',
    path: 'data.board_id',
  })
  let setBoardId = useDataChange({
    context: 'event_action',
    path: 'data.board_id',
    viewPath: props.viewPath,
  })

  return function onChange(value) {
    if (!boardId) return
    // Check if action's board exists in this location.
    // It might not if we consider the copy of automations between locations.
    let isBoardPresent = value?.find(item => item.id === boardId)
    if (!isBoardPresent) {
      setBoardId(null)
      return
    }
  }
}
